import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { routes } from 'const';

export default () => {
  const { t, i18n } = useTranslation('labels');
  const options = useMemo(
    () => [
      {
        link: routes.settings,
        label: t('profile'),
      },
      {
        link: routes.account,
        label: t('account'),
      },
      {
        link: routes.payment,
        label: t('payment'),
      },
    ],
    [i18n.language],
  );
  return { data: options };
};
